/**
 * @description 请求资源的blob类型，然后转成base64 data url 返回
 * @param {string} url 请求的url
 * @param {RequestInit | undefined} config fetch的第二个参数
 * @returns {Promise<string>} base64的data url
 */
const fetchBlobConvertToBase64 = (
  url: RequestInfo,
  config?: RequestInit | undefined,
): Promise<string> => {
  return new Promise((resolve, reject) => {
    fetch(url, config)
      .then(res => {
        res.blob().then(blob => {
          const reader = new FileReader();
          reader.onload = function (e: ProgressEvent<FileReader>) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            resolve(e.target!.result as string);
          };
          reader.readAsDataURL(blob);
        });
      })
      .catch(err => {
        reject(err);
      });
  });
};

export default fetchBlobConvertToBase64;
